import React from 'react';
import colors from "assets/theme/colors.js";

const InfoIcon = React.forwardRef((props, ref) => (
    <span
      ref={ref}
      {...props}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '4px',
        cursor: 'help',
        opacity: 0.7,
        position: 'relative',
        top: '-1.5px',
        ...props.style,
      }}
    >
      <i
        className="material-icons"
        style={{
          fontSize: '13px',
          color: colors.gray[600],
          lineHeight: 1,
          display: 'block'
        }}
      >
        info
      </i>
    </span>
));

InfoIcon.displayName = 'InfoIcon';

export default InfoIcon;
